import i18next from 'i18next';
import { Resource } from 'shared/interfaces/Resource';

export interface DeleteGoogleDriveAccountConflictDto {
  message: string;
  error: string;
  resources?: Resource[];
}

export interface GoogleDriveAuthCredentials {
  accessToken: string;
  refreshToken: string;
  scope: string;
  tokenType: string;
  expiryDate: number;
}

export interface GoogleDriveUserInfo {
  displayName: string;
  email: string;
  photoLink: string;
}

export interface GoogleDriveAccount {
  _id: string;
  credentials: GoogleDriveAuthCredentials;
  userInfo: GoogleDriveUserInfo;
  user: string;
}

export interface GoogleDriveAuthUrl {
  url: string;
}

export interface GoogleDriveFileInfo {
  mimeType: string;
  name: string;
  id: string;
  parents: string[];
  googleDriveAccountId: string;
}

export interface GoogleDriveFilesSearchQueryResult {
  files: GoogleDriveFileInfo[];
  nextPageToken?: string;
}

export interface GetGoogleDriveFilesDto {
  googleDriveId: string;
  folderId?: string;
  pageToken?: string;
  searchQuery?: string;
}

export enum GoogleDriveMimeType {
  PDF = 'application/pdf',
  DOCUMENT = 'application/vnd.google-apps.document',
  FOLDER = 'application/vnd.google-apps.folder',
  SLIDES = 'application/vnd.google-apps.presentation'
}

export const googleDriveMimeTypeToReadableName = (mimeType: GoogleDriveMimeType) => {
  switch (mimeType) {
    case GoogleDriveMimeType.PDF:
      return i18next.t('GOOGLE_DRIVE.MIME_TYPE.PDF');
    case GoogleDriveMimeType.DOCUMENT:
      return i18next.t('GOOGLE_DRIVE.MIME_TYPE.DOCUMENT');
    case GoogleDriveMimeType.FOLDER:
      return i18next.t('GOOGLE_DRIVE.MIME_TYPE.FOLDER');
    case GoogleDriveMimeType.SLIDES:
      return i18next.t('GOOGLE_DRIVE.MIME_TYPE.SLIDES');
  }
};

export const GOOGLE_DRIVE_ROOT = {
  id: 'root',
  name: '/',
  mimeType: GoogleDriveMimeType.FOLDER,
  parents: [],
  googleDriveAccountId: '' // Will be set later.
} as GoogleDriveFileInfo;

export interface GoogleDriveResourceFile {
  googleDriveAccountId: string;
  fileId: string;
  fileName: string;
  mimeType: GoogleDriveMimeType;
  webViewLink: string;
  lastRefresh: number;
  recursive: boolean;
}

export interface GoogleDriveFiles {
  files: GoogleDriveFile[];
}

export interface GoogleDriveFile {
  fileId: string;
  // Legacy files don't have a name set
  name?: string;
  mimeType: GoogleDriveMimeType;
  pages: GoogleDrivePageText[];
}

export interface GoogleDrivePageText {
  pageNumber: number;
  text: string;
}
